import { createAction, props } from '@ngrx/store';
import {SpesenItem} from "../../spesen.model";

export const deleteSpeseStart = createAction('ZEIT::DELETE_SPESE_START', props<{ item: SpesenItem}>());
export const deleteSpeseSucceeded = createAction('ZEIT::DELETE_SPESE_SUCCEEDED', props<{ item: SpesenItem }>(), );
export const deleteSpeseFailed = createAction('ZEIT::DELETE_SPESE_FAILED', props<{ error: Error }>());
